import MultiArgsFilter from './multi-args-filter/MultiArgsFilter';

export default class MultiSelectType extends MultiArgsFilter {
    constructor(element, parent) {
        super(element, parent);
        this.listWrapper = element.querySelector('.gravity-block-filters__multi-select-wrapper');
        this.list = this.listWrapper?.querySelector('ul');
        this.listElements = this.list?.querySelectorAll('li') ?? [];
        this.listHeight = this.list?.offsetHeight;
        this.openButton = element.querySelector('.gravity-block-filters__multi-select-button');
        this.countWrapper = element.querySelector('.gravity-block-filters__multi-select-count');
        this.isOpen = false;
        this.selectedItemsCount = 0;
        this.type = this.list?.dataset.type;
        this.document = document;

        if (this.type === 'taxonomy') {
            this.taxonomySlug = this.list.dataset.taxonomy;
        }

        this.toggleListVisibility = this.toggleListVisibility.bind(this);
        this.changeState = this.changeState.bind(this);
        this.checkFocusoutTarget = this.checkFocusoutTarget.bind(this);
    }

    init() {
        if (this.list === null) {
            return;
        }

        this.registerEvents();

        this.updateInitialValues();
    }

    get filterTaxonomySlug() {
        return this.taxonomySlug ?? '';
    }

    get filterType() {
        return this.type ?? '';
    }

    registerEvents() {
        if (!this.openButton) {
            return;
        }

        this.openButton.addEventListener('click', this.toggleListVisibility);
        this.element.addEventListener('focusout', (event) => {
            this.checkFocusoutTarget(event, true);
        });

        [...this.listElements].forEach((listItem) => {
            listItem.addEventListener('keydown', (event) => {
                const keyCode = event.which.toString();

                // Enter or space key
                if (keyCode === '13' || keyCode === '32') {
                    event.preventDefault();

                    this.changeState(event);
                }
            });

            listItem.addEventListener('click', (event) => {
                event.stopPropagation();

                this.changeState(event);
            });
        });
    }

    checkFocusoutTarget(event, related = false) {
        if (!this.element.contains(related ? event.relatedTarget : event.target)) {
            this.close();
        }
    }

    updateInitialValues() {
        // Check if exist filter args for this type
        if (!this.hasFilterArgs()) {
            return;
        }

        const selectedSlugs = this.getFilterArgs();

        if (selectedSlugs) {
            [...this.listElements].forEach((item) => {
                if (selectedSlugs.includes(item.dataset.slug)) {
                    item.classList.add('active');
                    this.updateItemsCount(false);
                }
            });
        }
    }

    get itemsCount() {
        return this.selectedItemsCount;
    }

    set itemsCount(count) {
        this.selectedItemsCount = count;

        this.updateLabels();
    }

    toggleListVisibility() {
        this.isOpen = !this.isOpen;

        if (this.isOpen) {
            this.document.addEventListener('mousedown', this.checkFocusoutTarget);
            this.listWrapper.style.height = `${this.listHeight}px`;
            this.openButton.classList.add('active');
        } else {
            this.listWrapper.style.height = null;
            this.openButton.classList.remove('active');
        }

        this.openButton.setAttribute('aria-expanded', this.isOpen);
    }

    close() {
        this.isOpen = false;
        this.listWrapper.style.height = null;
        this.openButton.setAttribute('aria-expanded', this.isOpen);
        this.openButton.classList.remove('active');
        document.removeEventListener('mousedown', this.checkFocusoutTarget);
    }

    changeState(event) {
        const changedItem = event.target;
        const isActive = changedItem.classList.contains('active');
        const { slug } = changedItem.dataset;
        changedItem.classList.toggle('active');

        this.updateFilterArgs(slug, isActive);

        this.updateItemsCount(isActive);
        this.updateLabels();

        if (!this.parent.hasApplyButton) {
            this.parent.sendFiltersChange(event.target);
        }
    }

    updateItemsCount(isActive) {
        if (isActive) {
            this.itemsCount--;
        } else {
            this.itemsCount++;
        }
    }

    updateLabels() {
        if (this.itemsCount > 0) {
            this.countWrapper.textContent = this.itemsCount;
        } else {
            this.countWrapper.textContent = '';
        }
    }

    clear() {
        [...this.element.querySelectorAll('li.active')].forEach((item) => item.classList.remove('active'));

        this.itemsCount = 0;
    }
}
